// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyDQ5XEedVJb1kbrN2HehuwOcAJT0bxRNSI",
  authDomain: "taskly-5214c.firebaseapp.com",
  projectId: "taskly-5214c",
  storageBucket: "taskly-5214c.firebasestorage.app",
  messagingSenderId: "837457173604",
  appId: "1:837457173604:web:cb1c003405764452f45371"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Export services
const auth = getAuth(app);
const db = getFirestore(app);

export { app, auth, db };
